<div class="container-fluid">
  <div class="row">
    <div class="col-xl-1"></div>

    <div class="col-xl-10">

      <div class="card mb-3">
        <div class="card-header d-flex justify-content-between align-items-center">

          <div class="d-flex align-items-center">
            <fa-icon [icon]="['fas','gavel']" size="lg" class="me-2" [fixedWidth]="true">
            </fa-icon>

            {{ caseTitle }}
          </div>

          <button class="btn btn-sm btn-blue text-bold" (click)="navigateBack()">
            {{ 'button.back' | translate }}
          </button>
        </div>

        <div class="card-body pt-0">

          @if (isLoading) {
            <div class="mt-4">
              <div class="case-card card border-0 shadow-sm w-100">
                <div class="card-body p-4">
                  <div class="d-flex justify-content-between align-items-start flex-wrap gap-3">
                    <div class="min-w-0 flex-grow-1">
                      <div class="skeleton skeleton-eyebrow mb-2"></div>
                      <div class="skeleton skeleton-title mb-3"></div>
                      <div class="d-flex flex-wrap align-items-center gap-3">
                        <div class="skeleton skeleton-meta"></div>
                        <div class="skeleton skeleton-meta"></div>
                      </div>
                    </div>
                    <div class="skeleton skeleton-box"></div>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (!isLoading) {
            <div class="mt-4">
              <div class="case-card card border-0 shadow-sm w-100 mb-4">
                <div class="card-body pt-0 pb-3">
                  <div class="case-info-panel">
                    <div class="case-info-head">
                      <div class="case-info-title">
                        {{ 'label.case-info-bankruptcy' | translate }}
                      </div>
                      <div class="case-number-box case-number-box--fixed">
                        <div class="case-number-label">{{ 'label.casenumber' | translate }}</div>
                        <div class="case-number-value">{{ detailed?.caseNumber || '-' }}</div>
                      </div>
                    </div>
                    <div class="case-info-group">
                      <div class="meta-grid meta-grid--3">
                        <div class="meta-item">
                          <div class="meta-label">{{ 'label.orgnr' | translate }}</div>
                          <div class="meta-value">{{ detailed?.caseOrgNr || '-' }}</div>
                        </div>
                        <div class="meta-item min-w-0">
                          <div class="meta-label">{{ 'label.court' | translate }}</div>
                          <div class="meta-value text-truncate">{{ detailed?.caseCourtName || '-' }}</div>
                        </div>
                        <div class="meta-item">
                          <div class="meta-label">{{ 'label.bankruptcy-date' | translate }}</div>
                          <div class="meta-value">
                            {{ detailed?.caseDecisionDate ? (detailed.caseDecisionDate | date:'yyyy-MM-dd') : '-' }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="case-info-group">
                      <div class="meta-grid">
                        @if (detailed?.trusteeName) {
                          <div class="meta-item min-w-0">
                            <div class="meta-label">{{ 'label.trustee' | translate }}</div>
                            <div class="meta-value text-truncate">{{ detailed.trusteeName || '-' }}</div>
                          </div>
                        }
                        <div class="meta-item min-w-0">
                          <div class="meta-label">{{ 'label.lawfirm' | translate }}</div>
                          <div class="meta-value text-truncate">{{ detailed?.trusteeLawfirm || '-' }}</div>
                        </div>
                      </div>
                    </div>
                    @if (hasProofOfDebtDates) {
                      <div class="case-info-group">
                        <div class="meta-grid meta-grid--3">
                          @if (detailed?.proofOfDebtStarted) {
                            <div class="meta-item">
                              <div class="meta-label">{{ 'label.proof-of-debt-starts' | translate }}</div>
                              <div class="meta-value">
                                {{ detailed?.proofOfDebtStarted ? (detailed.proofOfDebtStarted | date:'yyyy-MM-dd') : '-' }}
                              </div>
                            </div>
                          }
                          @if (detailed?.proofOfDebtDeadline) {
                            <div class="meta-item">
                              <div class="meta-label">{{ 'label.proof-of-debt-ends' | translate }}</div>
                              <div class="meta-value">{{ detailed?.proofOfDebtDeadline ? (detailed.proofOfDebtDeadline | date:'yyyy-MM-dd') : '-' }}</div>
                            </div>
                          }
                          @if (detailed?.remarksDeadline) {
                            <div class="meta-item">
                              <div class="meta-label">{{ 'label.last-day-remarks' | translate }}</div>
                              <div class="meta-value">{{ detailed?.remarksDeadline ? (detailed.remarksDeadline | date:'yyyy-MM-dd') : '-' }}</div>
                            </div>
                          }
                        </div>
                      </div>
                    }
                    <div class="case-info-group">
                      <div class="proof-of-debt-info">
                        <button
                          type="button"
                          class="proof-of-debt-info__toggle d-flex align-items-center justify-content-between gap-3 w-100 px-3 py-2"
                          [attr.aria-expanded]="isProofOfDebtInfoExpanded"
                          aria-controls="proof-of-debt-info-body"
                          (click)="toggleProofOfDebtInfo()">
                          <span class="d-inline-flex align-items-center gap-2">
                            <fa-icon [icon]="['fas', 'circle-question']" class="proof-of-debt-info__question-icon"></fa-icon>
                            {{ 'proof-of-debt-info.toggle' | translate }}
                          </span>
                          <fa-icon [icon]="['fas', isProofOfDebtInfoExpanded ? 'chevron-up' : 'chevron-down']"></fa-icon>
                        </button>
                        <div id="proof-of-debt-info-body" [ngbCollapse]="!isProofOfDebtInfoExpanded">
                          <div class="proof-of-debt-info__body px-3 pb-3">
                            <p
                              class="mt-1 mb-2"
                              [innerHTML]="'proof-of-debt-info.registration-text' | translate"></p>
                            <p
                              class="mb-2"
                              [innerHTML]="'proof-of-debt-info.proof-of-debt-text' | translate"></p>
                            <p class="mb-2">{{ 'proof-of-debt-info.advance-dividend-text' | translate }}</p>
                            <p class="mb-2">{{ 'proof-of-debt-info.consequence-text' | translate }}</p>
                            <p class="proof-of-debt-info__contact mb-0">{{ 'proof-of-debt-info.contact-text' | translate }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              @if (showSubmitSuccess) {
                <div class="submit-success-banner">
                  <fa-icon [icon]="['fas', 'check-circle']" class="submit-success-icon"></fa-icon>
                  {{ 'texts.submit-success' | translate }}
                </div>
              }
              @if (banner; as b) {
                <div class="process-banner"
              [ngClass]="{
                'process-banner--info': b.variant === 'info',
                'process-banner--success': b.variant === 'success',
                'process-banner--warning': b.variant === 'warning',
                'process-banner--danger': b.variant === 'danger'
              }">
                  <div class="process-banner__title">{{ b.title | translate }}</div>
                  <div class="process-banner__text">{{ b.text | translate }}</div>
                </div>
              }
              @if (anmalningar.length > 0 || bevakningar.length > 0) {
                <div class="list-controls">
                  <div class="controls-row">
                    @if (anmalningar.length > 10 || bevakningar.length > 10) {
                      <div class="search-wrapper">
                        <div class="search-input-row">
                          <fa-icon [icon]="['fas', 'search']" class="search-icon"></fa-icon>
                          <input
                            type="text"
                            class="search-input"
                            [value]="searchTerm"
                            (input)="searchTerm = $any($event.target).value"
                            (keydown.escape)="clearSearch()"
                            [placeholder]="'placeholder.search-claims' | translate"
                            autocomplete="off">
                          @if (searchTerm) {
                            <button
                              type="button"
                              class="search-clear-btn"
                              [title]="'button.avbryt' | translate"
                              (click)="clearSearch()">
                              <fa-icon [icon]="['fas', 'times']"></fa-icon>
                            </button>
                          }
                        </div>
                      </div>
                    }
                    <button class="sort-btn" type="button" (click)="toggleSortDirection()">
                      <fa-icon [icon]="['fas', sortDirection === 'desc' ? 'arrow-down' : 'arrow-up']" class="me-1"></fa-icon>
                      {{ (sortDirection === 'desc' ? 'button.sort-newest-first' : 'button.sort-oldest-first') | translate }}
                    </button>
                  </div>
                </div>
              }
              <div class="lists-panel" [class.lists-panel--single]="hasOnlyOneList()">
                @if (allowPreRequests || anmalningar.length > 0) {
                  <div class="list-card list-card--anmalningar card border-0 shadow-sm">
                    <div class="card-header d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <fa-icon [icon]="['fas', 'bell']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>
                        {{ 'label.mina-anmalningar' | translate }}
                        @if (isSearchActive) {
                          <span class="search-count-badge">
                            {{ filteredAnmalningar.length }}&thinsp;/&thinsp;{{ anmalningar.length }}
                          </span>
                        }
                      </div>
                      @if (allowPreRequests) {
                        <button class="btn btn-sm btn-blue text-bold" type="button"
                          (click)="createPreRequest()">
                          {{ 'button.create-new' | translate }}
                        </button>
                      }
                    </div>
                    <div class="list-body">
                      <div class="rows">
                        @if (!anmalningar || anmalningar.length === 0) {
                          <div class="list-empty-all">
                            {{ 'texts.no-pre-requests-yet' | translate }}
                          </div>
                        }
                        @if (anmalningar.length > 0 && filteredAnmalningar.length === 0) {
                          <div class="list-empty-all list-empty-search">
                            {{ 'texts.no-search-results' | translate: { term: searchTerm } }}
                          </div>
                        }
                        @for (a of filteredAnmalningar; track trackById($index, a)) {
                          <div class="row-item row-item--anmalan"
                            [class.row-item--declined]="a.isDeclined"
                            [class.row-item--new]="a.id === newlySubmittedId"
                            [attr.role]="a.isDeclined ? null : 'button'"
                            [attr.tabindex]="a.isDeclined ? -1 : 0"
                      [title]="a.isDeclined ? ('texts.removed-by-case-handler' | translate) :
                        (a.requiresAttention ? ('texts.remark-from-handler' | translate) :
                        (a.hasRemark ? ('texts.remark-handled' | translate) : ('texts.handled-by-case-handler' | translate)))"
                            (click)="!a.isDeclined && viewClaim(a)">
                            <div class="row-left">
                              <div class="row-nameline">
                                <div class="row-name">
                                  @if (a.isDeclined) {
                                    <fa-icon [icon]="['fas','times-circle']" class="declined-icon"></fa-icon>
                                  }
                                  @if (!a.isDeclined && a.requiresAttention) {
                                    <fa-icon [icon]="['fas', 'message']" class="declined-icon"></fa-icon>
                                  }
                                  @if (!a.isDeclined && !a.requiresAttention && a.hasRemark) {
                                    <fa-icon [icon]="['fas', 'message']" class="ok-icon"></fa-icon>
                                  }
                                  {{ a.creditorName }}
                                </div>
                                @if (a.id && a.creditorId) {
                                  <button
                                    type="button"
                                    class="receipt-btn"
                                    [class.receipt-btn--loading]="downloadingReceiptId === a.id"
                                    [disabled]="downloadingReceiptId === a.id"
                                    [title]="(downloadingReceiptId === a.id ? 'button.downloading-receipt' : 'button.download-receipt') | translate"
                                    [attr.aria-label]="(downloadingReceiptId === a.id ? 'button.downloading-receipt' : 'button.download-receipt') | translate"
                                    (click)="downloadReceipt(a, $event)">
                                    @if (downloadingReceiptId !== a.id) {
                                      <fa-icon [icon]="['fas', 'file-pdf']"></fa-icon>
                                    }
                                    @if (downloadingReceiptId === a.id) {
                                      <fa-icon [icon]="['fas', 'circle-notch']" animation="spin"></fa-icon>
                                    }
                                  </button>
                                }
                              </div>
                              @if (a.submittedDate) {
                                <div class="row-date">{{ a.submittedDate | date:'yyyy-MM-dd' }}</div>
                              }
                            </div>
                            <div class="row-right">
                              <div class="row-topline">
                                <div class="row-types">
                                  <div class="row-type">{{ a.claimType | claimTypeLabel }}</div>
                                </div>
                                <div class="row-amount">
                                  {{ a.amount | number:'1.0-0' }} kr
                                </div>
                              </div>
                              @if (isProofOfDebtStage && !a.isDeclined) {
                                <button
                                  type="button"
                                  class="btn btn-sm btn-blue text-bold mt-1"
                                  [title]="'button.create-claim-title' | translate"
                                  (click)="$event.stopPropagation(); createProofOfDebtFromClaim(a)">
                                  {{ 'button.create-claim' | translate }}
                                </button>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
                @if (allowRequests || allowLateRequests || bevakningar.length > 0) {
                  <div
                    class="list-card card border-0 shadow-sm">
                    <div class="card-header d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <fa-icon [icon]="['fas', 'bell']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>
                        {{ 'label.mina-bevakningar' | translate }}
                        @if (isSearchActive) {
                          <span class="search-count-badge">
                            {{ filteredBevakningar.length }}&thinsp;/&thinsp;{{ bevakningar.length }}
                          </span>
                        }
                      </div>
                      @if (allowRequests || allowLateRequests) {
                        <button class="btn btn-sm btn-blue text-bold" type="button"
                          (click)="createProofOfDebt()">
                          {{ 'button.create-new' | translate }}
                        </button>
                      }
                    </div>
                    <div class="list-body">
                      <div class="rows">
                        @if (!bevakningar || bevakningar.length === 0) {
                          <div class="list-empty-all">
                            {{ 'texts.no-proof-of-debts-yet' | translate }}
                          </div>
                        }
                        @if (bevakningar.length > 0 && filteredBevakningar.length === 0) {
                          <div class="list-empty-all list-empty-search">
                            {{ 'texts.no-search-results' | translate: { term: searchTerm } }}
                          </div>
                        }
                        @for (b of filteredBevakningar; track trackById($index, b)) {
                          <div class="row-item"
                            [class.row-item--declined]="b.isDeclined"
                            [class.row-item--late]="b.isLateRequest"
                            [class.row-item--new]="b.id === newlySubmittedId"
                            [attr.role]="b.isDeclined ? null : 'button'"
                            [attr.tabindex]="b.isDeclined ? -1 : 0"
                      [title]="b.isDeclined ? ('texts.removed-by-case-handler' | translate) :
                        (b.requiresAttention ? ('texts.remark-from-handler' | translate) :
                        (b.hasRemark ? ('texts.remark-handled' | translate) : ('texts.handled-by-case-handler' | translate)))"
                            (click)="!b.isDeclined && viewProofOfDebt(b)">
                            <div class="row-left">
                              <div class="row-nameline">
                                <div class="row-name">
                                  @if (b.isDeclined) {
                                    <fa-icon [icon]="['fas','times-circle']" class="declined-icon"></fa-icon>
                                  }
                                  {{ b.creditorName }}
                                  @if (!b.isDeclined && b.requiresAttention) {
                                    <fa-icon [icon]="['fas', 'envelope']" class="declined-icon ms-2"></fa-icon>
                                  }
                                  @if (!b.isDeclined && !b.requiresAttention && b.hasRemark) {
                                    <fa-icon [icon]="['far', 'envelope']" class="ok-icon ms-2"></fa-icon>
                                  }
                                </div>
                                @if (b.id && b.creditorId) {
                                  <button
                                    type="button"
                                    class="receipt-btn"
                                    [class.receipt-btn--loading]="downloadingReceiptId === b.id"
                                    [disabled]="downloadingReceiptId === b.id"
                                    [title]="(downloadingReceiptId === b.id ? 'button.downloading-receipt' : 'button.download-receipt') | translate"
                                    [attr.aria-label]="(downloadingReceiptId === b.id ? 'button.downloading-receipt' : 'button.download-receipt') | translate"
                                    (click)="downloadReceipt(b, $event)">
                                    @if (downloadingReceiptId !== b.id) {
                                      <fa-icon [icon]="['fas', 'file-pdf']"></fa-icon>
                                    }
                                    @if (downloadingReceiptId === b.id) {
                                      <fa-icon [icon]="['fas', 'circle-notch']" animation="spin"></fa-icon>
                                    }
                                  </button>
                                }
                              </div>
                              @if (b.submittedDate) {
                                <div class="row-date">{{ b.submittedDate | date:'yyyy-MM-dd' }}</div>
                              }
                            </div>
                            <div class="row-right">
                              <div class="row-topline">
                                <div class="row-types">
                                  @if (b.isLateRequest) {
                                    <div class="row-type row-type--late">
                                      {{ 'label.sen-bevakning' | translate }}
                                    </div>
                                  }
                                  <div class="row-type">
                                    {{ b.claimType | claimTypeLabel }}
                                  </div>
                                </div>
                                <div class="row-amount">
                                  {{ b.amount | number:'1.0-0' }} kr
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }

        </div>
      </div>

    </div>
    <div class="col-xl-1"></div>
  </div>
</div>
